import { types, Instance } from 'mobx-state-tree';
const { model, identifierNumber, string, maybeNull } = types;

export const googleProfileInfoModel = model('googleProfileInfoModel', {
  id: identifierNumber,
  organizationName: maybeNull(string),
  fullName: string,
  email: string,
  password: string,
  confirm_password: string,
  title: maybeNull(string),
  department: maybeNull(string),
  phone: maybeNull(string),
  address: maybeNull(string),
});

export type IgoogleProfileInfoModel = Instance<typeof googleProfileInfoModel>;
